// glode-prodotto-init.js — script in pagina di prototipo/premium/prodotto.html (P26),
// adattato in P30 (10/09/2026) a leggere i dati da Shopify invece che dal file statico.
//
// Cosa e' cambiato rispetto all'originale, e nient'altro:
//  1. montaTelaio() rimossa: testata, piede e cassetto sono quelli di Horizon;
//  2. le immagini arrivano gia' come indirizzi completi della CDN — `p.img` e `p.scene`, che
//     Liquid riempie da `product.media` — quindi cadono i prefissi `'../'`;
//  3. FUOCO_PDP e' indicizzata per nome file e gli indirizzi della CDN hanno la query `?v=`:
//     si toglie prima di cercare, altrimenti la centratura al 55% smetterebbe di applicarsi;
//  4. l'aggiunta al carrello e' il form nativo di Shopify, nel markup della sezione: qui non
//     si chiama piu' carrelloAggiungi, che scriveva nel carrello finto del prototipo.
// La geometria della galleria — set v45, riempimento al 55%, varianti di layout — non e' toccata.
const p = skuCorrente();
document.title = `${p.nome} — Glodé`;
// Briciole, famiglia, titolo, valutazione, descrizione e chips ora sono markup Liquid: li scrive
// la sezione, non questo script. Riscriverli qui li avrebbe fatti sparire e ricomparire, e avrebbe
// creato due fonti per lo stesso testo. Restano qui solo l'immagine e tutto cio' che dipende dalla
// variante o e' derivato.
// Nota conservata dall'originale: niente «verificate» sulle recensioni, che NON lo sono
// (Dir. Omnibus — checklist §8, pre-battesimo).
document.getElementById('pdp-img').src = p.img;
document.getElementById('pdp-img').alt = `${p.nome} — ${p.formato}`;
// selettore formato a bottoni + prezzo SEPARATO che si aggiorna (CRO: mai il prezzo dentro le opzioni)
// P47 (14/09/2026): `corrente` è la VARIANTE selezionata (formato, prezzo, id, disponibilità). Cambiare
// formato cambia anche l'<input name="id"> del form nativo, il prezzo stampato dal Liquid, la barra
// sticky e l'etichetta del bottone: prima il selettore cambiava solo il prezzo a video, e nel carrello
// finiva il full size. Il full size è la prima variante e resta il default.
const VARIANTI = Array.isArray(p.varianti) && p.varianti.length ? p.varianti : [{ formato: p.formato, prezzo: p.prezzo, id: p.varianteId, disponibile: true }];
let corrente = VARIANTI.find(v => String(v.id) === String(p.varianteId)) || VARIANTI[0];
const prezzoLiquid = n => `${Math.floor(n)},${String(Math.round((n - Math.floor(n)) * 100)).padStart(2, '0')} €`; // «68,00 €», come lo stampa la sezione
function applicaVariante() {
  const form = document.getElementById('glode-form-prodotto');
  const campoId = form && form.querySelector('input[name="id"]');
  if (campoId && corrente.id) campoId.value = String(corrente.id).replace(/^gid:\/\/shopify\/ProductVariant\//, '');
  const prezzo = document.getElementById('pdp-prezzo'); if (prezzo) prezzo.textContent = prezzoLiquid(corrente.prezzo);
  const sticky = document.getElementById('sticky-prezzo'); if (sticky) sticky.textContent = prezzoLiquid(corrente.prezzo);
  const img = document.getElementById('pdp-img'); if (img) img.alt = `${p.nome} — ${corrente.formato}`;
  const cta = document.getElementById('pdp-cta'); const stickyCta = document.getElementById('sticky-cta');
  const nonDisponibile = corrente.disponibile === false;
  if (cta) cta.disabled = nonDisponibile; if (stickyCta) stickyCta.disabled = nonDisponibile;
  if (corrente.id && VARIANTI.length > 1 && window.history && history.replaceState) {
    const u = new URL(location.href); u.searchParams.set('variant', String(corrente.id).replace(/^gid:\/\/shopify\/ProductVariant\//, '')); history.replaceState(null, '', u);
  }
}
function applicaPrezzo() {
  // Il prezzo NON si riscrive qui. Lo stampa il Liquid della sezione, che i centesimi li gestisce;
  // questa riga faceva `.replace(' €', ',00 €')`, cioe' presumeva centesimi sempre a zero: al primo
  // 42,50 — uno sconto, una variante — il Liquid avrebbe scritto giusto e il JavaScript ci avrebbe
  // scritto sopra sbagliato, vincendo in silenzio. Vale anche per la barra sticky.
  const ml = parseInt((corrente.formato.match(/(\d+)\s*ml/i) || [])[1], 10);
  document.getElementById('pdp-prezzo-unit').textContent = ml
    ? `(${(corrente.prezzo / ml * 100).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} € / 100 ml)` : '';
  // P39: divergenza dichiarata 13. Senza contratto Scalapay la riga sarebbe una promessa falsa, quindi
  // si scrive solo se il negozio l'ha accesa dal Personalizza; l'elemento resta in pagina ma vuoto e
  // nascosto, così il markup non cambia e riaccenderla non richiede codice.
  const rate = document.getElementById('pdp-rate');
  // spenta è la posizione sicura: se l'oggetto non c'è, la riga non si scrive. Una promessa di
  // pagamento in più è un danno, una in meno è solo una riga che manca.
  const mostraRate = !!(window.GLODE_PAGAMENTI && window.GLODE_PAGAMENTI.rate === true);
  if (mostraRate) {
    const rata = (corrente.prezzo / 3).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    rate.innerHTML = `Paga in 3 rate senza interessi da <b>${rata} €</b> con <span class="scalapay-pill">scalapay</span>`;
    rate.hidden = false;
  } else {
    rate.innerHTML = '';
    rate.hidden = true;
  }
  const etichettaCta = document.getElementById('pdp-cta-testo') || document.getElementById('pdp-cta');
  if (etichettaCta) etichettaCta.textContent = corrente.disponibile === false ? 'Non disponibile' : `Aggiungi al rituale / ${fmtE(corrente.prezzo)}`;
  document.getElementById('pdp-formato').textContent = corrente.formato; // PAO e Uso esterno rimossi su richiesta cliente (pptx 20/07)
  const manca = Math.max(0, 69 - corrente.prezzo);
  document.getElementById('pdp-soglia').textContent = manca > 0
    ? `Aggiungi ${manca.toLocaleString('it-IT')} € al carrello per la spedizione gratuita`
    : 'Spedizione gratuita inclusa';
}
applicaPrezzo();

// P52: view_item per GA4. Il contenitore GTM-5DNBPGPM ha già il tag «GA4 - Event - view_item»
// su un trigger Evento personalizzato con lo stesso nome e `getEcommerceDataFrom: dataLayer`:
// qui si spinge solo { event, ecommerce }, la mappatura la fa GTM.
// `ecommerce: null` prima di ogni push, come fa il pixel del checkout: senza, GA4 tiene gli
// `items` dell'evento precedente e li mescola con questi.
// Si spinge UNA sola volta per pagina: al cambio formato NON si ri-spinge, perché GA4 conta
// view_item per pagina e nel contenitore non c'è un tag select_item a cui appoggiarsi.
// item_id è l'id NUMERICO della variante, la stessa forma che manda il pixel del checkout
// (`String(v.id)`, pixel-checkout-gtm.js:54): se di qui uscisse il gid, GA4 conterebbe due
// prodotti diversi nello stesso imbuto. item_brand è `p.vendor` sullo store, misurato «Glodé»
// su 13 prodotti su 13; item_category è `p.famiglia`, che glode-prodotto-voce.liquid:62 riempie
// da `p.type`, lo stesso campo che il pixel manda come item_category.
try {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'view_item',
    ecommerce: {
      currency: 'EUR',
      value: corrente.prezzo,
      items: [{
        item_id: String(corrente.id).replace(/^gid:\/\/shopify\/ProductVariant\//, ''),
        item_name: p.nome,
        item_variant: corrente.formato,
        item_brand: 'Glodé',
        item_category: p.famiglia,
        price: corrente.prezzo,
        quantity: 1,
      }],
    },
  });
} catch (e) { /* un evento di misura non deve mai fermare la scheda */ }
// il selettore compare solo con almeno due varianti (con una sola, com'era prima di P47, resta nascosto);
// all'arrivo NON si riscrive il prezzo: lo ha già stampato il Liquid per la variante selezionata
if (VARIANTI.length > 1) {
  const box = document.getElementById('pdp-varianti'), op = document.getElementById('formato-opzioni');
  box.hidden = false;
  document.querySelector('.pannello-card').classList.add('pdp-varianti-attive'); // il selettore mostra già il formato: la riga «30 ml» si nasconde (CSS)
  const attiva = Math.max(0, VARIANTI.indexOf(corrente));
  op.innerHTML = VARIANTI.map((v, i) =>
    `<button type="button" role="radio" aria-checked="${i === attiva}" class="formato-btn${i === attiva ? ' attivo' : ''}" data-i="${i}"${v.disponibile === false ? ' aria-disabled="true"' : ''}>${v.formato}</button>`).join('');
  op.addEventListener('click', e => {
    const b = e.target.closest('.formato-btn');
    if (!b) return;
    corrente = VARIANTI[+b.dataset.i];
    op.querySelectorAll('.formato-btn').forEach(x => { x.classList.toggle('attivo', x === b); x.setAttribute('aria-checked', x === b); });
    applicaPrezzo();
    applicaVariante();
  });
}
// niente listener: il pulsante e' il submit del form nativo di Shopify, nel markup della sezione

// barra d'acquisto sticky su mobile: compare quando il CTA principale esce dallo schermo verso l'alto
const sticky = document.getElementById('atc-sticky');
// niente listener: anche questo e' un submit, associato al form nativo con l'attributo form=
new IntersectionObserver(([e]) => {
  sticky.hidden = e.isIntersecting || e.boundingClientRect.top > 0;
}, { threshold: 0 }).observe(document.getElementById('pdp-cta'));
// Modo d'uso e INCI sono markup Liquid nelle sezioni: testo di legge e di prodotto, deve stare
// nell'HTML servito anche senza JavaScript. La banda #rituale resta come approfondimento sotto e
// il pannello «Modo d'uso» resta il riepilogo (B.10, call 27/08: il campo e' gia' breve).
document.getElementById('uso-vai-rituale').addEventListener('click', () => { const s = document.getElementById('rituale'); if (s) s.scrollIntoView({ behavior: 'smooth' }); });
// dropdown «Gli attivi» (decisione call 27/08 estesa a tutte e 4 le voci): recap = nome + prima
// frase della scheda di ogni attivo chiave; la banda completa resta sotto
document.getElementById('pdp-attivi-scheda').innerHTML = (p.attivi || []).slice(0, 4).map(a =>
  `<p><b>${a.nome}</b> — ${(a.testo.split(/(?<=\.)\s+/)[0] || '')}</p>`).join('');
document.getElementById('attivi-vai-banda').addEventListener('click', () => { const s = document.getElementById('attivi'); if (s) s.scrollIntoView({ behavior: 'smooth' }); });

// riga «attivi chiave» nel pannello (anchor alla sezione attivi)
const att = p.attivi || [];
document.getElementById('pdp-attivi-line').innerHTML = att.length
  ? `Attivi chiave: <b>${att.slice(0, 3).map(a => a.nome).join('</b> · <b>')}</b> — <a href="#attivi">Scopri la formula ↓</a>` : '';

// fascia trust a tutta larghezza SOPRA la scheda (call 27/08 B.5 «in alto al prodotto»,
// precisata il 03/09: non un badge nel pannello ma una fascia sopra, reference Kmax)
const ICONA_TRUST = {
  testato: '<path d="M12 3l7 3v5.4c0 4.3-2.9 7.7-7 9.6-4.1-1.9-7-5.3-7-9.6V6l7-3z"/><path d="M9 12.3l2.1 2.1L15.4 10"/>',
  origine: '<circle cx="12" cy="9" r="5.6"/><path d="M8.6 13.9L7.2 21l4.8-2.4L16.8 21l-1.4-7.1"/>'
};
document.getElementById('pdp-trust').innerHTML = [
  { i: 'testato', t: p.claim },
  { i: 'origine', t: CLAIM_LINEA }
].map(v => `<span class="trust-voce"><svg viewBox="0 0 24 24" width="17" height="17" fill="none"
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
    aria-hidden="true">${ICONA_TRUST[v.i]}</svg><b>${v.t}</b></span>`).join('');

// banda «La formula»: prima frase come display, ~2 frasi visibili, resto dietro expander
const frasi = (p.descrizione_formula || p.descrizione).split(/(?<=\.)\s+/).filter(Boolean);
document.getElementById('formula-frase').textContent = frasi[0] || '';
const visibili = [], nascoste = [];
let quota = 0;
for (const f of frasi.slice(1)) {
  if (quota + f.length <= 420) { visibili.push(f); quota += f.length; } else nascoste.push(f);
}
document.getElementById('formula-testo').textContent = visibili.join(' ');
if (nascoste.length) {
  document.getElementById('formula-extra').hidden = false;
  document.getElementById('formula-resto').textContent = nascoste.join(' ');
}

// sezione «Gli attivi»: 4 card hero + resto in mini-accordion dietro toggle (≤5 attivi: tutte card)
const soglia = att.length <= 5 ? att.length : 4;
const hero = att.slice(0, soglia), altri = att.slice(soglia);
document.getElementById('attivi-hero').innerHTML = hero.map((a, i) =>
  `<article class="attivo-card"><span class="attivo-num">${String(i + 1).padStart(2, '0')}</span><h3>${a.nome}</h3><p>${a.testo}</p></article>`).join('');
document.getElementById('attivi-conta').textContent = `${att.length} attivi funzionali`;
if (altri.length) {
  document.getElementById('attivi-resto').innerHTML = altri.map(a =>
    `<details class="attivo-riga"><summary>${a.nome}</summary><p>${a.testo}</p></details>`).join('');
  const tg = document.getElementById('attivi-toggle');
  tg.hidden = false;
  tg.textContent = `Vedi tutti gli attivi (${att.length})`;
  tg.addEventListener('click', () => {
    const resto = document.getElementById('attivi-resto');
    resto.hidden = !resto.hidden;
    tg.textContent = resto.hidden ? `Vedi tutti gli attivi (${att.length})` : 'Mostra meno';
  });
}
document.getElementById('attivi-inci-link').addEventListener('click', e => {
  e.preventDefault();
  const d = document.getElementById('acc-inci');
  d.open = true;
  d.scrollIntoView({ behavior: 'smooth', block: 'center' });
});

// FAQ generate SOLO dai dati esistenti (niente contenuti inventati)
const faq = [
  { d: 'Per chi è indicato?', r: `Per pelle ${p.tipo_pelle.join(', ').toLowerCase()}. Risponde alle esigenze: ${p.esigenze.join(', ').toLowerCase()}.` },
  { d: 'Come si usa?', r: p.modo_uso },
  { d: 'È testato?', r: `${p.claim}. Made in Italy — Panestetic Srl, Ciserano (BG).` },
  { d: 'In che formati esiste?', r: VARIANTI.length > 1 ? VARIANTI.map(v => `${v.formato} (${fmtE(v.prezzo)})`).join(' e ') + '.' : `${p.formato}.` }, // P47: il prezzo nella risposta solo con più formati, come nel prototipo
];
document.getElementById('pdp-faq').innerHTML = faq.map(f => `<details><summary>${f.d}</summary><p>${f.r}</p></details>`).join('');

document.getElementById('pdp-reviews').innerHTML = p.recensioni.map(r =>
  `<div class="recensione"><span class="stelle">★★★★★</span><p>${r.testo}</p><cite>${r.autore}, ${r.eta} anni</cite></div>`).join('');

// cross-sell: catene UFFICIALI del Riepilogo 13/07 (02-prodotti/cross-sell.md), fallback famiglia+popolari
const GESTO = { 'Detergenti': '01 · Detergi', 'Esfolianti': '01 · Detergi', 'Sieri': '02 · Attiva', 'Contorno occhi e labbra': '02 · Attiva', 'Creme': '03 · Sigilla', 'Maschere': '03 · Sigilla' };
const correlati = (p.cross_sell || []).map(s => P.find(x => x.sku === s)).filter(Boolean);
const listaCross = correlati.length ? correlati : crossSell(p, 3);
document.getElementById('pdp-cross').className = 'griglia ' + (listaCross.length === 4 ? 'griglia-quattro' : 'griglia-tre');
document.getElementById('pdp-cross').innerHTML = listaCross.map(x =>
  `<div class="cross-item"><span class="cross-step">Gesto ${GESTO[x.famiglia] || ''}</span>${tile(x)}</div>`).join('');

// Galleria con thumbnails (stile Rhode): scena + packshot + slide info + foto di famiglia.
// Un solo packshot: i «tre fondi» avevano senso coi render provvisori (il multiply li sfumava
// diversi); con le FOTO DEF scontornate erano tre viste quasi identiche (segnalazione utente 17/08)
// le foto di gruppo restano asset del tema: non sono immagini di prodotto su Shopify
const gruppo = p.famiglia === 'Creme' ? '../assets/img/gruppo-creme.png'
  : (p.famiglia === 'Contorno occhi e labbra' ? '../assets/img/gruppo-occhi.jpeg' : null);
const viste = [
  { fondo: 'fondo-bianco', img: p.img, srcset: p.imgSrcset, thumb: p.imgThumb, rapporto: p.imgRapporto },
];
// Gli scatti ambientati arrivano da product.media come {src, srcset, thumb}: `src` e' il taglio
// grande, `srcset` lascia scegliere al browser, `thumb` e' la miniatura da 200 px — i pollici sono
// alti settanta pixel e prima scaricavano l'immagine intera. FOTO_SCENA resta come ripiego per il
// prototipo, e li' non ci sono tagli: si usa lo stesso file per tutto.
const scatti = (p.scene && p.scene.length)
  ? p.scene.map(x => (typeof x === 'string' ? { src: x } : x)).filter(v => v && v.src)
  : (FOTO_SCENA[p.sku] || []).map(s => ({ src: '../' + s }));
scatti.slice().reverse().forEach(v => viste.unshift({ fondo: 'vista-foto', img: v.src, srcset: v.srcset, thumb: v.thumb, rapporto: v.rapporto }));
if (gruppo) viste.push({ fondo: 'fondo-perla', img: gruppo });
// vista video di utilizzo (B.11): solo per gli SKU con campo video_uso nei dati
if (p.video_uso) viste.splice(1, 0, { etichetta: 'Video', classeThumb: ' thumb-video', html: `<video autoplay muted loop playsinline preload="metadata" src="../${p.video_uso.src}" poster="${p.video_uso.poster ? '../' + p.video_uso.poster : p.img}"></video>` });

// LAYOUT DELLA SCHEDA PRODOTTO — deciso il 09/09: la versione 4:5 («audrer3») è quella NORMALE, su
// tutti e 13 i prodotti, senza bisogno di parametro. È la scheda nata dalla reference Audrer mandata dal
// cliente (call 27/08, «l'immagine tipo reel è troppo grande»): riquadro 4:5 dichiarato — lo stesso formato
// in cui il cliente produce i propri visual — prodotto al 55% dell'altezza uguale su tutte le schede (set
// v45 in FUOCO_PDP, calcolato dai bounding box misurati) e nome del prodotto a 48px con la CTA nel primo
// schermo. Le versioni scartate restano raggiungibili per confronti interni: ?variante=quadrata (1:1),
// ?variante=audrer e ?variante=audrer2 (riquadro 2:3), ?variante=originale (layout storico, nessuna classe).
// Le impostazioni della sezione (window.GLODE_GALLERIA) decidono riquadro, centratura,
// adattamento e zoom. Il `?variante=` continua a vincere, perche' serve ai confronti interni.
const CFG = window.GLODE_GALLERIA || {};
const varRichiesta = new URLSearchParams(location.search).get('variante') || CFG.rapporto;
const varPdp = varRichiesta === 'originale' ? null : (varRichiesta || 'audrer3');
const centraturaMisurata = CFG.centratura !== false;
const zoomExtra = (Number(CFG.zoom) || 100) / 100;
if (varPdp === 'quadrata' || varPdp === 'audrer' || varPdp === 'audrer2' || varPdp === 'audrer3') {
  document.querySelector('.pdp-grid').classList.add('pdp-v-' + varPdp);
  // audrer2 e audrer3 ereditano il pannello compatto di audrer e sovrascrivono solo la galleria
  if (varPdp === 'audrer2' || varPdp === 'audrer3') document.querySelector('.pdp-grid').classList.add('pdp-v-audrer');
  // REGOLA (31/08): le foto ambientate col fondale brand restano le PRIME della galleria —
  // il packshot bianco NON apre mai. Il «prodotto subito visibile» si ottiene con zoom e
  // fuoco basso sulla foto scena (CSS .pdp-v-*), come nella reference Audrer.
  // audrer2 (feedback 01/09, confronto con PDP Audrer): prodotto INTERO con aria attorno,
  // box che sta nel primo schermo — finestra di crop centrata sul prodotto, zoom moderato.
  // audrer3 (feedback 08/09): stesso trattamento del prodotto di audrer2 ma box 4:5 DICHIARATO.
  // Il 4:5 è il formato in cui il cliente produce i propri visual (cartella Drive «ATTIVI GLODE»,
  // 13 PNG 1080×1350): un box 4:5 li ospita senza ritagliarli.
}

// slide informative (richiesta cliente pptx 20/07, pattern Miamo): solo dati ufficiali delle schede,
// composte in HTML in attesa delle immagini AI definitive del cliente
const TINTE = ['tinta-lavanda', 'tinta-perla', 'tinta-navy', 'tinta-prugna'];
const infoSlides = [];
// Vista «Attivi»: infografica ufficiale del cliente (ATTIVI_IMG in premium.js). È un'immagine su fondo
// bianco con il testo a ~5% dal bordo: resa con object-fit: contain (mai cover) e mai come prima vista.
// Sostituisce la slide HTML a quadranti, che resta solo come ripiego per SKU senza infografica.
if (ATTIVI_IMG[p.sku]) infoSlides.push({ etichetta: 'Attivi', fondo: 'vista-attivi', img: '../' + ATTIVI_IMG[p.sku] });
else if (att.length) infoSlides.push({
  etichetta: 'Attivi',
  html: `<div class="slide-info">
    <p class="slide-info-titolo">Principi attivi funzionali</p>
    <div class="slide-quadranti">${att.slice(0, 4).map((a, i) =>
      `<div class="quadrante ${TINTE[i]}"><b>${a.nome}</b></div>`).join('')}
      <img class="slide-pack" src="${p.img}" alt="${p.nome}">
    </div>
  </div>`,
});
infoSlides.push({
  etichetta: 'Benefici',
  html: `<div class="slide-info">
    <p class="slide-info-titolo">A cosa risponde</p>
    <div class="benefici-corpo">
      <img class="benefici-pack" src="${p.img}" alt="${p.nome}">
      <ul class="benefici-lista">${p.esigenze.map(x => `<li>${x}</li>`).join('')}</ul>
    </div>
    <p class="slide-footnote">${p.claim}. Made in Italy.</p>
  </div>`,
});
// slide «Risultati» SOLO per gli SKU con dati propri (B.12, call 27/08): i numeri di linea
// hard-coded per tutti i 13 SKU non erano sostenibili (claim 655/2013 + «i test non esistono
// per tutti»). DECISIONE, non regressione: senza campo `risultati` la slide non si genera.
if (p.risultati) infoSlides.push({
  etichetta: 'Risultati',
  classeThumb: ' thumb-risultati',
  html: `<div class="slide-info slide-risultati">
    <p class="slide-info-titolo">Risultati reali</p>
    <div class="risultati-corpo">${p.risultati.dati.map(d => `<div><b>${d.valore}</b><span>${d.label}</span></div>`).join('')}</div>
    <p class="slide-footnote">${p.risultati.fonte}</p>
  </div>`,
});
viste.splice(Math.min(2, viste.length), 0, ...infoSlides);

const main = document.getElementById('galleria-main');
const thumbs = document.getElementById('thumbs');
const slot = document.createElement('div');
slot.id = 'pdp-info-slide';
slot.hidden = true;
main.appendChild(slot);
function mostraVista(v) {
  const img = document.getElementById('pdp-img');
  if (v.html) {
    main.className = 'galleria-main vista-info';
    img.hidden = true;
    slot.hidden = false;
    slot.innerHTML = v.html;
  } else {
    main.className = 'galleria-main ' + v.fondo;
    slot.hidden = true;
    slot.innerHTML = ''; // ferma eventuali video muted che girerebbero nascosti
    img.hidden = false;
    // `sizes` **prima** di `srcset`: il browser sceglie il candidato nel momento in cui gli si
    // assegna srcset, e se sizes non e' ancora impostato usa 100vw — la larghezza della finestra
    // invece dei 640 px del box. Senza queste righe le viste diverse dalla prima restavano col
    // srcset del markup iniziale, che descrive un'altra immagine.
    img.src = v.img;
    if (v.srcset) {
      img.sizes = '(min-width: 900px) 640px, 100vw';
      img.srcset = v.srcset;
    } else {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
    }
    // varianti PDP: centratura PER-SCATTO del prodotto nelle foto scena (mappa FUOCO_PDP in
    // premium.js, valori misurati da scripts/qa/wrap-fuoco-misura.html). object-position mette
    // il centro-prodotto in corrispondenza, scale attorno a quel punto, translate (in % del box)
    // lo porta al centro. Scatti non mappati → fallback CSS della variante.
    img.removeAttribute('style'); // reset: nessuna vista eredita gli stili della precedente
    // il nome file sopravvive alla CDN (.../files/scena-2-1.jpg?v=…): si toglie la query,
    // altrimenti la chiave non combacia e la centratura al 55% non si applica piu'
    const nomeFile = String(v.img || '').split('/').pop().split('?')[0];

    // LA CENTRATURA MISURATA SI APPLICA SOLO SE L'IMMAGINE HA ANCORA BISOGNO DI ESSERE RITAGLIATA.
    //
    // I valori di FUOCO_PDP nascono dal prototipo, dove `scena-2-1.jpg` e' l'originale 1200x1800
    // (rapporto 0,667): li' lo zoom e il punto di fuoco servono a portare il prodotto al 55% dentro
    // un box 4:5 partendo da una foto piu' stretta. Su Shopify abbiamo caricato i ritagli 4:5 di
    // P23b, che quel 55% **ce l'hanno gia' dentro**: rapporto 0,8000 contro un box 0,800. Applicare
    // di nuovo zoom e fuoco vuol dire ritagliare una seconda volta un'immagine gia' ritagliata, ed
    // e' il flacone ingigantito che si vede.
    //
    // La condizione sta sul **dato**, non su un interruttore: si confronta il rapporto dell'immagine
    // con quello del box **misurato dal DOM**. Cosi' le texture (0,6667) e qualunque scatto futuro
    // con un rapporto diverso continuano a essere centrati come oggi, e i ritagli 4:5 no. Se il box
    // non e' ancora misurabile si applica la centratura, che e' il comportamento di prima.
    const riquadro = main.getBoundingClientRect();
    const rapportoBox = riquadro.height > 0 ? riquadro.width / riquadro.height : null;
    const giaRitagliata = rapportoBox !== null && v.rapporto
      && Math.abs(v.rapporto - rapportoBox) < 0.01;

    // Un'immagine gia' ritagliata non va solo esclusa dalla centratura misurata: va anche
    // protetta dal **ripiego CSS**. `tema/assets/glode.css:234` fa
    // `.pdp-v-audrer .galleria-main.vista-foto img { transform: scale(1.45); transform-origin: 50% 80% }`,
    // nato come rete per gli scatti senza voce in FUOCO_PDP. Sui ritagli 4:5 ingrandisce del 45%
    // un'immagine che non ha niente da ritagliare. Il foglio non si tocca, perche' si rigenera dai
    // fogli del prototipo: lo si annulla in linea, con la stessa condizione sul dato.
    if (giaRitagliata) {
      img.style.transform = 'none';
      img.style.objectPosition = '50% 50%';
    }

    const fp = !giaRitagliata && centraturaMisurata && varPdp && v.fondo === 'vista-foto'
      && window.FUOCO_PDP && FUOCO_PDP[nomeFile];
    // adattamento e zoom dall'impostazione: 'auto' lascia decidere alla CSS del riquadro
    if (CFG.adattamento && CFG.adattamento !== 'auto') img.style.objectFit = CFG.adattamento;
    if (fp && varPdp === 'audrer3' && fp.v45) {
      // audrer3 (box 4:5 dichiarato): valori del set v45, calcolati da scripts/qa/fuoco-valori.mjs sui
      // bounding box MISURATI (scripts/qa/fuoco-bbox.js) con fill 0.55 scelto da Mohamed l'08/09 dalla
      // griglia dei ritagli: prodotto alto il 55% del box e centrato in TUTTE le schede. Niente tetto allo
      // zoom (annullava la normalizzazione) e niente spostamento fisso (docs/AUDIT-B-PDP-2026-09-08.md).
      img.style.objectPosition = fp.v45.pos;
      img.style.transformOrigin = fp.v45.pos;
      img.style.transform = `translate(${fp.v45.tx}%, ${fp.v45.ty}%) scale(${fp.v45.z * zoomExtra})`;
    } else if (fp && varPdp === 'audrer2' && fp.a) {
      // audrer2 (variante non scelta, lasciata com'era): zoom col tetto 1,22 e prodotto alzato di 15 punti
      const z2 = Math.min(fp.a.z, 1.22);
      img.style.objectPosition = fp.a.pos;
      img.style.transformOrigin = fp.a.pos;
      img.style.transform = `translate(${fp.a.tx}%, ${fp.a.ty - 15}%) scale(${z2 * zoomExtra})`;
    } else if (!fp && zoomExtra !== 1) {
      img.style.transform = `scale(${zoomExtra})`;
    } else {
      const fv = fp && fp[varPdp === 'audrer' ? 'a' : 'q'];
      if (fv) {
        img.style.objectPosition = fv.pos;
        img.style.transformOrigin = fv.pos;
        img.style.transform = `translate(${fv.tx}%, ${fv.ty}%) scale(${fv.z * zoomExtra})`;
      }
    }
  }
}
thumbs.innerHTML = viste.map((v, i) => (v.html || v.etichetta)
  ? `<button class="thumb thumb-info${v.classeThumb || ''}${i === 0 ? ' attivo' : ''}" data-i="${i}" type="button" aria-label="${v.etichetta}"><span>${v.etichetta}</span></button>`
  : `<button class="thumb ${v.fondo}${i === 0 ? ' attivo' : ''}" data-i="${i}" type="button" aria-label="Vista ${i + 1}"><img src="${v.thumb || v.img}" alt="" loading="lazy" width="140" height="175"></button>`).join('');
mostraVista(viste[0]);
thumbs.addEventListener('click', e => {
  const b = e.target.closest('.thumb');
  if (!b) return;
  mostraVista(viste[+b.dataset.i]);
  thumbs.querySelectorAll('.thumb').forEach(t => t.classList.toggle('attivo', t === b));
});

// media della banda formula: texture-shot se esiste, altrimenti scatto ambientato, altrimenti packshot
const scena = (p.scene && p.scene.length)
  ? p.scene.map(x => (typeof x === 'string' ? { src: x } : x)).filter(v => v && v.src)
  : (FOTO_SCENA[p.sku] || []).map(s => ({ src: '../' + s }));
const fimg = document.getElementById('formula-img');
// `v.src &&`: un indirizzo mancante deve far saltare una vista, non fermare il renderer.
// Senza questa guardia un solo campo vuoto azzerava tutta la scheda, come CLAIM_LINEA.
const texture = scena.find(v => v.src && v.src.includes('-texture'));
const sceltaFormula = texture || scena[0];
fimg.src = sceltaFormula ? sceltaFormula.src : p.img;
if (sceltaFormula && sceltaFormula.srcset) { fimg.srcset = sceltaFormula.srcset; fimg.sizes = '(min-width: 900px) 560px, 100vw'; }
fimg.alt = `${p.nome} — la texture`;
